
import { defineComponent, computed, ref, Ref } from 'vue'
import AppHeader from '@/components/Header.vue'
import DeviceFooter from '@/components/device/Footer.vue'
import { Field, Uploader, Toast } from 'vant'
import getCacheFaultBillInfo from '@/compositions/fault/device'
import getRoute from '@/compositions/route'
import uploadFilesSetup from '@/compositions/uploadFiles'
import { CacheFaultBill } from '@/types/fault'
import { ImageInfo, UploadFile } from '@/types/public'
import { copy } from '@/utils/index'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'Fault-Voucher',
  components: {
    AppHeader,
    DeviceFooter,
    VanField: Field,
    VanUploader: Uploader,
  },
  setup() {
    const { cacheFaultBill, cacheCompleteDevices, cacheComponents } = getCacheFaultBillInfo()
    const { uploadFiles, getFiles } = uploadFilesSetup()
    const { params } = getRoute()
    const sn: string = params.value.sn as string
    const obj = cacheComponents.value.find((it) => it.serial_number === sn)
    let describe: Ref<string> = ref(obj?.describe || '')
    const fileList = ref(obj?.imgs || [])
    // 拥有ImageInfo格式的普通页面缓存数据
    const fileObjArr: Ref<ImageInfo[]> = ref(obj?.imgs || [])
    const store = useStore()
    const describeLen = computed((): number => describe.value.length)
    const fLen = computed((): number => fileList.value.length)
    const isCanClick = computed(() => !!(fileObjArr.value.length || describeLen.value))
    return {
      $store: store,
      describe,
      describeLen,
      isCanClick,
      cacheFaultBill,
      cacheCompleteDevices,
      cacheComponents,
      fileList,
      fLen,
      sn,
      uploadFiles,
      getFiles,
      fileObjArr,
    }
  },
  methods: {
    afterRead(files: UploadFile[] | UploadFile): void {
      files = Array.isArray(files) ? files : [files]
      files.forEach((it) => {
        it.status = 'uploading'
        it.message = '上传中...'
      })
      this.uploadFiles(files).then((data) => {
        if (data?.fileStrArr?.length) {
          const { fileStrArr, files } = data
          this.getFiles(files, fileStrArr).then((res) => {
            if (res?.fileObjArr?.length) {
              const { fileObjArr, files } = res
              files.forEach((it) => {
                it.status = 'done'
                it.message = '上传完成'
              })
              // 确保fileList的对象项一定有uid
              const fileList: UploadFile[] | ImageInfo[] = this.fileList.filter(
                (it: UploadFile | ImageInfo): boolean => !it?.uid
              )
              fileList.forEach((it: UploadFile | ImageInfo, i: number): void => {
                it.uid = fileObjArr[i].uid
              })
              this.fileObjArr.push(...fileObjArr)
            }
          })
        }
      })
    },
    beforeDelete(file: ImageInfo | UploadFile) {
      this.fileObjArr = this.fileObjArr.filter((it) => it.uid !== file.uid)
      return true
    },
    onSubmitForm(): void {
      // 虚假的零件设备，不加入缓存，跳转单据页面
      // 多了字和图片提交不成功报错
      if (!this.cacheFaultBill?.id) {
        Toast('缺少报修单')
        return
      }
      const cacheComponents = copy(this.cacheComponents)
      const isHasDevice = cacheComponents.some((it) => {
        if (it.serial_number === this.sn) {
          it.imgs = this.fileObjArr
          it.describe = this.describe
          return true
        }
      })
      if (!isHasDevice) {
        Toast('非法零件设备')
        this.$router.replace({ name: 'fault-form' })
        return
      } else {
        if (this.describeLen > 200) {
          Toast('购买时间说明不能大于200字')
          return
        }
        if (this.fLen > 3) {
          Toast('凭证附图不能大于3张')
          return
        }
        const cacheFaultBill: CacheFaultBill = copy(this.cacheFaultBill)
        cacheFaultBill.devices = [...cacheComponents, ...this.cacheCompleteDevices]
        this.$store.commit('setFaultBill', cacheFaultBill)
        this.$router.replace({ name: 'fault-form' })
      }
    },
  },
})
